import { id, list, listsRetrievalError } from "@planzone/dto";
import { areListsRetrievalFilters } from "../../utils/areListsRetrievalFilters";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getListsRetrievalError({ uuid }, filter) {
      const res = getState().find(
        ({ project, filter: f }) =>
          project.uuid === uuid && areListsRetrievalFilters(filter, f),
      );

      return res ? res.error : listsRetrievalError;
    },
    getLists({ uuid }, filter) {
      const res = getState().find(
        ({ project, filter: f }) =>
          project.uuid === uuid && areListsRetrievalFilters(filter, f),
      );

      return res ? res.lists : { ...list, uuid: id };
    },
    isListsRetrievalRequestFailure({ uuid }, filter) {
      const res = getState().find(
        ({ project, filter: f }) =>
          project.uuid === uuid && areListsRetrievalFilters(filter, f),
      );

      return res ? res.request.isFailure : false;
    },
    isListsRetrievalRequestPending({ uuid }, filter) {
      const res = getState().find(
        ({ project, filter: f }) =>
          project.uuid === uuid && areListsRetrievalFilters(filter, f),
      );

      return res ? res.request.isPending : false;
    },
    isListsRetrievalRequestSuccess({ uuid }, filter) {
      const res = getState().find(
        ({ project, filter: f }) =>
          project.uuid === uuid && areListsRetrievalFilters(filter, f),
      );

      return res ? res.request.isSuccessful : false;
    },
    canRetrieveNextLists({ uuid }, filter) {
      const res = getState().find(
        ({ project, filter: f }) =>
          project.uuid === uuid && areListsRetrievalFilters(filter, f),
      );

      return res ? res.canRetrieveNextProjects : true;
    },
    getListsCallCount({ uuid }, filter) {
      const res = getState().find(
        ({ project, filter: f }) =>
          project.uuid === uuid && areListsRetrievalFilters(filter, f),
      );

      return res ? res.callCount : 0;
    },
  };
}

export { createSelector };
